import type { ReactNode } from "react";
import { classNames } from "../styles/classNames";

interface ChoiceCardProps {
  /** Radio buttons of one choice share a name. */
  name: string;
  checked: boolean;
  onChoose: () => void;
  title: ReactNode;
  description?: ReactNode;
  /** Something beside the text, such as a copy button for the chosen thing's reference. */
  aside?: ReactNode;
}

/**
 * One option of a choice that needs a sentence to explain it, shown as a selectable card.
 * Choosing the chosen option again also tells the host, as a list that closes on a choice
 * needs to close again when the same option is kept.
 */
export default function ChoiceCard({ name, checked, onChoose, title, description, aside }: ChoiceCardProps) {
  return (
    <label className={classNames("app-choice-card flex cursor-pointer items-start gap-3 p-3", checked && "app-choice-card-selected")}>
      <input type="radio" name={name} className="app-choice-input mt-1" checked={checked} onChange={onChoose} onClick={checked ? onChoose : undefined} />
      <span className="min-w-0 space-y-0.5">
        <span className="app-choice-title block text-sm">{title}</span>
        {description === undefined || description === "" ? null : <span className="app-choice-description block text-xs">{description}</span>}
      </span>
      {aside === undefined ? null : <span className="ml-auto shrink-0">{aside}</span>}
    </label>
  );
}
